// test381
(381 && 0);
